import { BpAnchor } from '../../components/text/anchor/BpAnchor'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface LandingPageCellProps {
  link_screen_url: string
}

export const LandingPageCell = ({ link_screen_url }: LandingPageCellProps) => {
  const { t } = useTranslation()

  return (
    <BpAnchor href={link_screen_url} target='_blank'>
      {t('buttons.viewScreenshot')}
    </BpAnchor>
  )
}
